// extracted by mini-css-extract-plugin
export default {"CategoryFilterContainer":"CategoryFilter_CategoryFilterContainer__EjJOa"};